module.exports = __webpack_public_path__ + "static/media/tucker-logo.6090c570.jpg";